import { Routes } from '@angular/router';
import { authGuard, dashboardGuard, guestGuard, roleGuard } from './core/guards';
import type { Role } from './core/models';

const STAFF: Role[] = ['Admin', 'SubAdmin'];
const OPS: Role[] = ['Admin', 'SubAdmin', 'Company', 'SunilensSpecialAdmin', 'Collector', 'SuperUserCollector'];

export const routes: Routes = [
  { path: 'login', canActivate: [guestGuard], loadComponent: () => import('./pages/auth-pages').then((m) => m.LoginPage) },
  { path: 'reset-password', loadComponent: () => import('./pages/auth-pages').then((m) => m.ResetPasswordPage) },
  { path: 'no-access', loadComponent: () => import('./pages/auth-pages').then((m) => m.NoAccessPage) },
  {
    path: '',
    canActivate: [authGuard],
    loadComponent: () => import('./layout/shell').then((m) => m.Shell),
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'dashboard' },
      { path: 'dashboard', canActivate: [dashboardGuard], loadComponent: () => import('./pages/dashboard.page').then((m) => m.DashboardPage) },
      { path: 'appointments', canActivate: [roleGuard], data: { roles: OPS }, loadComponent: () => import('./pages/appointments.page').then((m) => m.AppointmentsPage) },
      {
        path: 'bags',
        canActivate: [roleGuard],
        data: { roles: ['Admin', 'SubAdmin', 'Collector', 'SuperUserCollector'] },
        loadComponent: () => import('./pages/misc.pages').then((m) => m.BagsPage),
      },
      { path: 'schedules', canActivate: [roleGuard], data: { roles: OPS }, loadComponent: () => import('./pages/catalog.pages').then((m) => m.SchedulesPage) },
      { path: 'municipalities', canActivate: [roleGuard], data: { roles: STAFF }, loadComponent: () => import('./pages/catalog.pages').then((m) => m.MunicipalitiesPage) },
      { path: 'regions', canActivate: [roleGuard], data: { roles: STAFF }, loadComponent: () => import('./pages/catalog.pages').then((m) => m.RegionsPage) },
      { path: 'companies', canActivate: [roleGuard], data: { roles: STAFF }, loadComponent: () => import('./pages/catalog.pages').then((m) => m.CompaniesPage) },
      { path: 'recycle-types', canActivate: [roleGuard], data: { roles: STAFF }, loadComponent: () => import('./pages/catalog.pages').then((m) => m.RecycleTypesPage) },
      { path: 'prize-budgets', canActivate: [roleGuard], data: { roles: STAFF }, loadComponent: () => import('./pages/catalog.pages').then((m) => m.PrizeBudgetsPage) },
      { path: 'smart-bins', canActivate: [roleGuard], data: { roles: STAFF }, loadComponent: () => import('./pages/catalog.pages').then((m) => m.SmartBinsPage) },
      { path: 'users', canActivate: [roleGuard], data: { roles: STAFF }, loadComponent: () => import('./pages/users.page').then((m) => m.UsersPage) },
      { path: 'rewards', canActivate: [roleGuard], data: { roles: STAFF }, loadComponent: () => import('./pages/rewards.page').then((m) => m.RewardsPage) },
      { path: 'qr-codes', canActivate: [roleGuard], data: { roles: STAFF }, loadComponent: () => import('./pages/misc.pages').then((m) => m.QrCodesPage) },
      { path: 'audit', canActivate: [roleGuard], data: { roles: ['Admin'] }, loadComponent: () => import('./pages/misc.pages').then((m) => m.AuditPage) },
    ],
  },
  { path: '**', redirectTo: '' },
];
